import React from 'react'
import SliderTestimonial from '../../component/slidercomponent/SliderTestimonial'

const HomeTestimonials = () => {
    return (
        <>

            <div className="testimonial-area tm-bg pt-80 pb-60" style={{marginTop:"-60px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="site-heading wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <span className="site-title-tagline"><i className="fas fa-solar-panel" /> Testimonials</span>
                                <h2 className="site-title text-white">What Our Client <span>Say's</span> about us</h2>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="testimonial-slider owl-carousel owl-theme wow fadeInUp owl-loaded owl-drag" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="owl-stage-outer">
                                        <SliderTestimonial />

                                    {/* <div className="owl-stage" style={{ transform: 'translate3d(-806px, 0px, 0px)', transition: '0.25s', width: 3224 }}>

                                        <div className="owl-item cloned" style={{ width: 373, marginRight: 30 }}><div className="testimonial-item">
                                            <div className="testimonial-quote">
                                                <div className="testimonial-rate">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <div className="testimonial-quote-icon">
                                                    <img src="assets/img/icon/quote.svg" alt />
                                                </div>
                                                <p>
                                                    There are many variations passage available the majority have suffered of alteration in some form by the injected humour or randomised words which look even slightly believable.
                                                </p>
                                            </div>
                                            <div className="testimonial-content">
                                                <div className="testimonial-author-img">
                                                    <img src="assets/img/testimonial/03.jpg" alt />
                                                </div>
                                                <div className="testimonial-author-info">
                                                    <h4>Ebony Swihart</h4>
                                                    <p>Customer</p>
                                                </div>
                                            </div>
                                        </div></div>
                                        <div className="owl-item cloned" style={{ width: 373, marginRight: 30 }}><div className="testimonial-item">
                                            <div className="testimonial-quote">
                                                <div className="testimonial-rate">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <div className="testimonial-quote-icon">
                                                    <img src="assets/img/icon/quote.svg" alt />
                                                </div>
                                                <p>
                                                    There are many variations passage available the majority have suffered of alteration in some form by the injected humour or randomised words which look even slightly believable.
                                                </p>
                                            </div>
                                            <div className="testimonial-content">
                                                <div className="testimonial-author-img">
                                                    <img src="assets/img/testimonial/04.jpg" alt />
                                                </div>
                                                <div className="testimonial-author-info">
                                                    <h4>Loreta Jones</h4>
                                                    <p>Customer</p>
                                                </div>
                                            </div>
                                        </div></div>
                                        <div className="owl-item active" style={{ width: 373, marginRight: 30 }}><div className="testimonial-item">
                                            <div className="testimonial-quote">
                                                <div className="testimonial-rate">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <div className="testimonial-quote-icon">
                                                    <img src="assets/img/icon/quote.svg" alt />
                                                </div>
                                                <p>
                                                    There are many variations passage available the majority have suffered of alteration in some form by the injected humour or randomised words which look even slightly believable.
                                                </p>
                                            </div>
                                            <div className="testimonial-content">
                                                <div className="testimonial-author-img">
                                                    <img src="assets/img/testimonial/01.jpg" alt />
                                                </div>
                                                <div className="testimonial-author-info">
                                                    <h4>Niesha Phips</h4>
                                                    <p>Customer</p>
                                                </div>
                                            </div>
                                        </div></div>
                                        <div className="owl-item active" style={{ width: 373, marginRight: 30 }}><div className="testimonial-item">
                                            <div className="testimonial-quote">
                                                <div className="testimonial-rate">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <div className="testimonial-quote-icon">
                                                    <img src="assets/img/icon/quote.svg" alt />
                                                </div>
                                                <p>
                                                    There are many variations passage available the majority have suffered of alteration in some form by the injected humour or randomised words which look even slightly believable.
                                                </p>
                                            </div>
                                            <div className="testimonial-content">
                                                <div className="testimonial-author-img">
                                                    <img src="assets/img/testimonial/02.jpg" alt />
                                                </div>
                                                <div className="testimonial-author-info">
                                                    <h4>Daniel Porter</h4>
                                                    <p>Customer</p>
                                                </div>
                                            </div>
                                        </div></div>
                                        <div className="owl-item" style={{ width: 373, marginRight: 30 }}><div className="testimonial-item">
                                            <div className="testimonial-quote">
                                                <div className="testimonial-rate">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <div className="testimonial-quote-icon">
                                                    <img src="assets/img/icon/quote.svg" alt />
                                                </div>
                                                <p>
                                                    There are many variations passage available the majority have suffered of alteration in some form by the injected humour or randomised words which look even slightly believable.
                                                </p>
                                            </div>
                                            <div className="testimonial-content">
                                                <div className="testimonial-author-img">
                                                    <img src="assets/img/testimonial/03.jpg" alt />
                                                </div>
                                                <div className="testimonial-author-info">
                                                    <h4>Ebony Swihart</h4>
                                                    <p>Customer</p>
                                                </div>
                                            </div>
                                        </div></div>
                                        <div className="owl-item" style={{ width: 373, marginRight: 30 }}><div className="testimonial-item">
                                            <div className="testimonial-quote">
                                                <div className="testimonial-rate">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <div className="testimonial-quote-icon">
                                                    <img src="assets/img/icon/quote.svg" alt />
                                                </div>
                                                <p>
                                                    There are many variations passage available the majority have suffered of alteration in some form by the injected humour or randomised words which look even slightly believable.
                                                </p>
                                            </div>
                                            <div className="testimonial-content">
                                                <div className="testimonial-author-img">
                                                    <img src="assets/img/testimonial/04.jpg" alt />
                                                </div>
                                                <div className="testimonial-author-info">
                                                    <h4>Loreta Jones</h4>
                                                    <p>Customer</p>
                                                </div>
                                            </div>
                                        </div></div>
                                        <div className="owl-item cloned" style={{ width: 373, marginRight: 30 }}><div className="testimonial-item">
                                            <div className="testimonial-quote">
                                                <div className="testimonial-rate">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <div className="testimonial-quote-icon">
                                                    <img src="assets/img/icon/quote.svg" alt />
                                                </div>
                                                <p>
                                                    There are many variations passage available the majority have suffered of alteration in some form by the injected humour or randomised words which look even slightly believable.
                                                </p>
                                            </div>
                                            <div className="testimonial-content">
                                                <div className="testimonial-author-img">
                                                    <img src="assets/img/testimonial/01.jpg" alt />
                                                </div>
                                                <div className="testimonial-author-info">
                                                    <h4>Niesha Phips</h4>
                                                    <p>Customer</p>
                                                </div>
                                            </div>
                                        </div></div>
                                        <div className="owl-item cloned" style={{ width: 373, marginRight: 30 }}><div className="testimonial-item">
                                            <div className="testimonial-quote">
                                                <div className="testimonial-rate">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <div className="testimonial-quote-icon">
                                                    <img src="assets/img/icon/quote.svg" alt />
                                                </div>
                                                <p>
                                                    There are many variations passage available the majority have suffered of alteration in some form by the injected humour or randomised words which look even slightly believable.
                                                </p>
                                            </div>
                                            <div className="testimonial-content">
                                                <div className="testimonial-author-img">
                                                    <img src="assets/img/testimonial/02.jpg" alt />
                                                </div>
                                                <div className="testimonial-author-info">
                                                    <h4>Daniel Porter</h4>
                                                    <p>Customer</p>
                                                </div>
                                            </div>
                                        </div></div>
                                    </div> */}
                                </div>
                                <div className="owl-nav disabled">
                                    <button type="button" role="presentation" className="owl-prev"><span aria-label="Previous">‹</span>
                                    </button>
                                    <button type="button" role="presentation" className="owl-next"><span aria-label="Next">›</span>
                                    </button>
                                </div>
                                <div className="owl-dots">
                                    <button role="button" className="owl-dot active">
                                        <span />
                                    </button>
                                    <button role="button" className="owl-dot"><span />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default HomeTestimonials